import React, { useCallback, useEffect, useRef, useState, } from 'react';
import classNames from 'classnames';
import useKeyPress from '../../../hooks/useKeyPress';
import './index.less';
var isKeySendCommand = function (keys) {
    if (keys.shiftKey) {
        return false;
    }
    return keys.key.toLowerCase() === 'enter';
};
var URL_PATTERN = /\b(?:(?:https?|ftp):\/\/|www\.|[a-z0-9-]+\.[a-z]{2,})(?:[^\s]*)/i;
var MAX_MESSAGE_LENGTH = 999;
var isAcceptedMessageLength = function (message) { return message.trim().length > 0 && message.length <= MAX_MESSAGE_LENGTH; };
// Function to detect if message contains a URL
var containsUrl = function (message) { return URL_PATTERN.test(message); };
var MessageTextField = function (_a) {
    var onSubmit = _a.onSubmit, className = _a.className, isSubmitDisabled = _a.isSubmitDisabled, message = _a.message, onMessageChange = _a.onMessageChange, _b = _a.focusRequest, focusRequest = _b === void 0 ? 0 : _b;
    var _c = useState(false), hasLink = _c[0], setHasLink = _c[1];
    var ref = useRef(null);
    var textareaRef = useRef(null);
    useEffect(function () {
        var _a;
        if (focusRequest > 0) {
            (_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [focusRequest]);
    var handleKeyPress = useCallback(function (event) {
        if (isKeySendCommand(event) && isAcceptedMessageLength(message)) {
            event.preventDefault();
            onSubmit(message);
            onMessageChange('');
            setHasLink(false);
        }
        // Our callback should only rerender when message changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message, hasLink]);
    useKeyPress(ref, handleKeyPress);
    var handleSubmit = function (evt) {
        evt.preventDefault();
        if (isAcceptedMessageLength(message)) {
            onSubmit(message);
            onMessageChange('');
            setHasLink(false);
        }
    };
    var handleChange = function (event) {
        var text = event.target.value;
        onMessageChange(text);
        setHasLink(containsUrl(text));
    };
    return React.createElement(React.Fragment, null,
        React.createElement("form", { ref: ref, onSubmit: handleSubmit, className: classNames('messagetextfield', className) },
            React.createElement("textarea", { ref: textareaRef, name: "message", className: classNames({ 'messagetextfield__textarea--error': message.length > MAX_MESSAGE_LENGTH || hasLink }), id: "inputMessage", cols: 30, rows: 10, placeholder: "Skriv meldingen din her", onChange: handleChange, value: message }),
            React.createElement("button", { "aria-label": "Svar", type: "submit", disabled: !isAcceptedMessageLength(message)
                    || isSubmitDisabled || hasLink },
                React.createElement("i", { className: "fas fa-reply fa-lg" }))),
        message.length > MAX_MESSAGE_LENGTH
            && React.createElement("p", { className: "messagetextfielderror" },
                "Meldingen er for lang. Den kan v\u00E6re maks ",
                MAX_MESSAGE_LENGTH,
                " tegn, din er ",
                message.length,
                "."),
        hasLink
            && React.createElement("p", { className: "messagetextfielderror" }, "Meldingen kan ikke inneholde lenker."));
};
export default MessageTextField;
